import addNewIcon from './add-icon.svg';
import iphone from './iphone.png';
import iphoneLandscape from './iphone-landscape.png';
import ipad from './ipad.png';
import ipadLandscape from './ipad-landscape.png';
import mouseScroll from './mouse-scroll.gif';
import layoutBackgroundIcon from './layout-background-icon.svg';
import circleProgressIndicator from './circle-progress-indicator.svg';

/* eslint-disable */
export {
  addNewIcon,
  iphone,
  iphoneLandscape,
  ipad,
  ipadLandscape,
  mouseScroll,
  layoutBackgroundIcon,
  circleProgressIndicator,
};
/* eslint-enable */



// WEBPACK FOOTER //
// ./app/javascript/packs/Shared/assets/images/index.js